export default "__VITE_ASSET__Dvj8ZSJb__"